let timeout = null
/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才能执行函数
 * @param {function} func 要执行的函数
 * @param {Number} wait 延时时间
 * @param {Boolean} immediate 是否立即执行
 */
export default function debounce(func, wait = 500, immediate = false) {
  if (timeout !== null) clearTimeout(timeout)
  if (immediate) {
    var callNow = !timeout
    timeout = setTimeout(() => {
      timeout = null
    }, wait)
    if (callNow) typeof func === 'function' && func()
  } else {
    timeout = setTimeout(() => {
      typeof func === 'function' && func()
    }, wait)
  }
}



// WEBPACK FOOTER //
// ./packages/utils/debounce.js